import {
  Box as MuiBox,
  Stack as MuiStack,
  Typography as MuiTypography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import OISSubheader from "./OISSubheader";
import OISRecentActivityTable from "./OISRecentActivityTable";

const OISContainer = () => {
  const { t } = useTranslation();
  return (
    <MuiBox
      id="ois-container"
      sx={{
        paddingY: 3,
        width: "100%",
      }}
    >
      <OISSubheader />
      <MuiStack gap={1.75}>
        <MuiTypography variant="h2" sx={{ fontSize: "21px", fontWeight: 100 }}>
          {t("ois.table.title")}
        </MuiTypography>
        <OISRecentActivityTable />
      </MuiStack>
    </MuiBox>
  );
};

export default OISContainer;
